// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { actionsStyles } from "@cahaba/Overrides/Widgets/ProductList/ProductListTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        overflow: auto;
        width: 100%;
    `,
};

actionsStyles.gridContainer = {
    gap: 0,
    css: css`
        padding: 30px 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        min-width: 320px;
                    `,
                    css`
                        max-width: 600px !important;
                    `,
                ],
                "min",
            )}
    `,
};

actionsStyles.productListActionsExtendedStyles = {
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin: 0px;
            button {
                border: none !important;
            }
            button:active,
            button:focus {
                border: 3px solid #09f !important;
                outline: none;
            }
        `,
    },
    productDetailsPriceText: {},
};

actionsStyles.productPrice = {
    savingsMessageText: {
        css: css`
            white-space: normal;
        `,
    },
};

actionsStyles.dataTableRow = {
    evenRowCss: css`
        background: ${getColor("common.background")};
    `,
};

actionsStyles.attributeWrapper = {
    css: css`
        min-width: 150px;
    `,
};
